function object_get(object, path, defaultValue)
{
	try {
		if (typeof path === "string") {
			path = path.split('.');
		}
		if (!Array.isArray(path)) {
			throw new TypeError("Argument [path] must be an array or a dot-notated string.");
		}
		var propKey = path.shift();
		if (object.hasOwnProperty(propKey)) {
			var propValue = object[propKey];
			if (typeof propValue === "object" && path.length > 0) {
				return object_get(propValue, path, defaultValue);
			} else {
				return propValue;
			}
		} else {
			return defaultValue;
		}
	} catch (e) {
		if (e instanceof TypeError) {
			console.error(e);
			return defaultValue;
		}
		throw e;
	}
}

require(
	[
	"jquery",
	"underscore",
	"api",
	"react",
	"shared/idlewatch",
	"jsx!components/viewbuncee",
	"jsx!components/viewbuncee-v3",
	"shared/crm",
	"shared/pwa-polyfill"
	],
	function($, _, APIClient, React, IdleWatch, AppComponent, AppComponentV3){
		if (window.appData.hasOwnProperty('user')) {
			window.api = new APIClient(window.appData.user.access_token, {
				baseURI: window.appData.client.api_url
			});
		}
		var app;
		if (window.appData.buncee.data.creation_version === 3) {
			app = React.createElement(AppComponentV3);
		} else {
			app = React.createElement(AppComponent);
		}
		
		React.render(app, document.getElementById('viewbuncee-wrapper'));
	},function(error){
		console.log(error);
	}
);
define("init_viewbuncee.js", function(){});

